<template>
  <div>
    <div
      :class="{'block-steps__row--warn': step.errors && step.errors.length}"
      class="block-steps__row"
      :data-index="index"
    >
      <div v-if="step.errors && step.errors.length">
        <popper :options="{placement: 'left'}">
          <div class="popper block-steps__warn-popover">
            <ul>
              <li v-for="err in step.errors" :key="err">{{ err }}</li>
            </ul>
          </div>
          <fai class="block-steps__row-warn-icon" icon="exclamation-circle" slot="reference"></fai>
        </popper>
      </div>

      <slot/>

      <div :style="{left: controlsLeft + 'px'}" class="block-steps__row-controls">
        <fai
          class="block-steps__row-control block-steps__row-control--drag-handler"
          icon="arrows-alt-v"
          size="lg"
        ></fai>
        <popper trigger="clickToOpen" :options="{placement: 'right'}">
          <div class="popper block-steps__del-popover">
            <p>{{ $t('view.flow.editor.sureQuestion') }}</p>
            <btn
              color="red"
              small
              icon="trash"
              @click="$emit('del', step.uuid)"
              class="block-steps__del-button"
            >{{ $t('view.flow.editor.delete') }}</btn>
          </div>
          <fai slot="reference" class="block-steps__row-control" icon="trash" size="lg"></fai>
        </popper>
      </div>
    </div>

    <steps-separator v-if="step.action === 'redirect'">{{ $t('view.flow.editor.endLine') }}</steps-separator>
    <steps-separator
      v-if="step.action === 'qr' && repliesEnd(step.replies)"
    >{{ $t('view.flow.editor.endLine') }}</steps-separator>
  </div>
</template>

<script>
export default {
  props: ['step', 'index'],
  data () {
    return {
      controlsLeft: 0
    }
  },
  methods: {
    repliesEnd (replies) {
      let r = 0
      for (let reply of replies) {
        if (reply.data.target) r++
      }

      if (r === replies.length) return true
      else return false
    },

    async calculateRowActionsOffset () {
      await this.delayMs(0)
      const content = this.$slots.default[0].elm.querySelector('*')
      this.controlsLeft = content.offsetWidth
    }
  },
  async mounted () {
    await this.calculateRowActionsOffset()
  }
}
</script>

<style lang="scss">
.block-steps {
  &__row {
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-content: center;
    margin-bottom: 8px;
    padding: 15px 0 5px 5px;
    margin-top: 5px;
    border-radius: 7px;
    transition: background-color 0.2s ease, border 0.2s ease,
      box-shadow 0.2s ease;
    will-change: background-color, border, box-shadow;

    &--warn {
      background-color: rgba(221, 115, 115, 0.251);
      border: 1px solid #DD7373;
      box-shadow: 0 0 5px #DD7373;
    }

    &:hover {
      & > .block-steps__row-controls {
        opacity: 1;
        pointer-events: all;
      }
    }
  }

  &__row-warn-icon {
    position: absolute;
    color: #DD7373;
    top: 4px;
    right: 5px;
    cursor: pointer;
  }

  &__warn-popover {
    text-align: left;

    ul {
      padding: 0px 10px 0px 25px;
      margin: 5px 0;
    }
  }

  &__row-controls {
    position: absolute;
    display: flex;
    flex-direction: column;
    width: 30px;
    height: 80px;
    top: calc(50% - 30px);
    min-width: 30px;
    align-content: center;
    margin-left: 15px;
    padding-right: 45px;
    opacity: 0;
    transition: opacity 0.1s ease;

    &:hover {
      opacity: 1;
    }
  }

  &__row-control {
    width: 30px;
    display: block;
    margin: 6px auto;
    cursor: pointer;

    &--drag-handler {
      cursor: move;
    }
  }

  &__del-popover {
    p {
      margin: 4px auto 10px auto;
    }
  }

  &__del-button {
    margin-bottom: 6px;
  }

  &__replies {
    max-width: 100%;
  }
}
</style>
